// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eoev-teaser.eoev-widget{overflow:inherit}.eoev-teaser.eoev-widget .v-application--wrap{display:block;flex:inherit;min-height:auto;min-width:inherit;width:100%;overflow-x:hidden}.eoev-teaser a.v-btn{border:inherit}.eoev-teaser-container.is-mobile{padding:0!important}", ""]);
// Exports
module.exports = exports;
